import { render } from "./TheFooterBottom.vue?vue&type=template&id=6d4a8e12&ts=true"
import script from "./TheFooterBottom.vue?vue&type=script&lang=ts"
export * from "./TheFooterBottom.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__